<script>
export default {
  props: {
    labelFor: { type: String, default: null },
    label: { type: String, default: null },
    error: { type: String, default: null },
  },
}
</script>

<template>
  <div class="w-full px-3 mb-6">
    <label v-if="label" class="label" :for="labelFor">
      {{ label }}
    </label>
    <slot />
    <p v-if="error" class="text-red-500 text-xs italic mt-2">{{ error }}</p>
  </div>
</template>
